import { render, staticRenderFns } from "./StackMessages.vue?vue&type=template&id=399157b6&scoped=true"
import script from "./StackMessages.vue?vue&type=script&lang=js"
export * from "./StackMessages.vue?vue&type=script&lang=js"
import style0 from "./StackMessages.vue?vue&type=style&index=0&id=399157b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399157b6",
  null
  
)

export default component.exports